export const APP_NAME = "BI SEMOG Engenharia";
export const APP_SHORT_NAME = "SEMOG";

export const ROUTES = {
  LOGIN:        "/login",
  HOME:         "/",
  DASHBOARD:    "/dashboard",
  SUPRIMENTOS:        "/suprimentos",
  SUPRIMENTOS_KANBAN: "/suprimentos/kanban",
  FINANCEIRO:   "/financeiro",
  ORCAMENTO:    "/orcamento",
  COMERCIAL:    "/comercial",
  GERENCIAL:    "/gerencial",
  /** Chão de Obra — módulo de primeiro nível (mesma permissão «gerencial»). */
  CHAO_DE_OBRA: "/chao-de-obra",
  SOLICITACAO_PAGAMENTO: "/solicitacao-pagamento",
  TAREFAS: "/tarefas",
  LOCACOES: "/locacoes",
  MANUTENCAO: "/manutencao",
  FOLHA_PAGAMENTOS: "/folha-pagamentos",
  /** App mobile-first para operadores de máquinas (vínculo em contrato ativo). */
  OPERADOR: "/operador",
  OPERADOR_HORIMETRO: "/operador/horimetro",
  OPERADOR_MANUTENCAO: "/operador/manutencao",
  ADMIN_ACESSO: "/admin/acesso",
  WHATSAPP:     "/admin/whatsapp",
  CHAMADOS_TI:  "/ti/chamados",
  /** Marketing — acesso direto por URL, fora do menu lateral principal. */
  MARKETING:    "/marketing",
  GENTE_GESTAO: "/gente-gestao",
  GENTE_GESTAO_VISAO: "/gente-gestao/visao",
  GENTE_GESTAO_COLABORADORES: "/gente-gestao/colaboradores",
  GENTE_GESTAO_NPS: "/gente-gestao/nps",
  GENTE_GESTAO_LIDERANCA: "/gente-gestao/lideranca",
  GENTE_GESTAO_LIDERANCA_COMPETENCIAS: "/gente-gestao/lideranca/competencias",
  GENTE_GESTAO_ESCUTA: "/gente-gestao/escuta",
  GENTE_GESTAO_DESLIGAMENTO: "/gente-gestao/desligamento",
} as const;

export const LOCAL_STORAGE_KEYS = {
  USER:          "semog_bi_user",
  SESSION_TOKEN: "semog_bi_session_token",
  /** Próxima atualização automática do Kanban (epoch ms) — persiste entre recarregamentos. */
  KANBAN_NEXT_REFRESH_AT: "semog_kanban_next_refresh_at",
  /** Última atualização concluída do Kanban (epoch ms). */
  KANBAN_LAST_REFRESH_AT: "semog_kanban_last_refresh_at",
} as const;

/** Kanban Suprimentos — obra Kambar: filtro padrão e atualização em segundo plano. */
export const SUPRIMENTOS_KANBAN_KAMBAR_PATTERN = /kambar/i;
export const SUPRIMENTOS_KANBAN_AUTO_REFRESH_MS = 15 * 60 * 1000;

/** Tarefas compartilhadas — atualização em segundo plano para refletir mudanças de outros usuários. */
export const TAREFAS_AUTO_REFRESH_MS = 30 * 1000;
